import React, {useContext} from "react";
import Nav from "./Nav";
import Menu from "./Menu";
import styled from "styled-components";
import {Content} from "../../styles/GlobalStyles";
import useIsMobile from "../../hooks/useIsMobile";
import MobileNav from "./components/MobileNav";
import MobileMenu from "./components/MobileMenu";
import {GlobalContext} from "../../context/GlobalContext";
import NewLetter from "../../views/modals/NewsLetter";

export default function Header({normal, secondary, primary, logoInvert, classname}) {
   const {menuIsOpen, setMenu} = useContext(GlobalContext);

   const isMobile = useIsMobile();

   return (
      <>
         {isMobile ? (
            <Content>
               <Head normal={false} left="0">
                  <MobileNav classname={classname} logoInvert={logoInvert} />
                  {menuIsOpen && <MobileMenu setMenu={setMenu} menuIsOpen={menuIsOpen} />}
               </Head>
            </Content>
         ) : (
            <Head normal={normal}>
               <Content>
                  <Nav base={secondary} logoInvert={logoInvert} />
                  <Menu base={primary} logoInvert={logoInvert} />
               </Content>
            </Head>
         )}
         <NewLetter />
      </>
   );
}

const Head = styled.header`
   width: calc(100% - 2em);
   position: absolute;
   top: 1em;
   left: ${props => props.left || "1em"};
   z-index: 10000;
   padding: 1.5em 0;
   padding-bottom: 0;

   @media screen and (max-width: 500px) {
      left: 0;
      top: 0;
      width: 100%;
   }
`;

Header.defaultProps = {
   normal: false,
   primary: "white",
   secondary: "white",
   logoInvert: false,
};
